import { compose } from 'ramda';
import { withApollo } from 'react-apollo';
import Stadium from './Stadium';

export default compose(withApollo)(Stadium);
